import { ProfileModel, profileApi } from '@pukka/api';
import { editOutletComparisonEvent } from '@pukka/clevertap/outletComparison';
import { queryClient } from '@pukka/tanstack-query';
import { Button } from '@pukka/ui-components';
import { OutletSelectorV2Modal } from '@pukka/ui-composite';
import { useSnapshot } from '@pukka/valtio';
import { QueryClientProvider } from '@tanstack/react-query';

import { DerivedState, State } from '../comparison.state';

function onSubmit(outlets: Set<ProfileModel.Outlet>) {
  return State.onReplace(
    ...[...outlets].map((outlet) => ({
      id: outlet.id ?? -1,
      name: outlet.name ?? '-',
    })),
  );
}

function AddOutlet() {
  const { selectedOutletIds } = useSnapshot(DerivedState);
  const { data: profile } = profileApi.useProfile();

  const handleSubmit = (outlets: Set<ProfileModel.Outlet>) => {
    editOutletComparisonEvent(outlets.size, profile);

    onSubmit(outlets);
  };

  return (
    <QueryClientProvider client={queryClient}>
      <OutletSelectorV2Modal onSubmit={handleSubmit} selectedIds={selectedOutletIds} minItems={2} maxItems={10}>
        <Button className="h-[426px] w-[238px] min-w-[238px] border-dashed" variant="secondary" focus="none">
          + Add Outlet
        </Button>
      </OutletSelectorV2Modal>
    </QueryClientProvider>
  );
}

export { AddOutlet, onSubmit as _onSubmit };
